module.exports = __webpack_public_path__ + "img/zip-midtown.d1f26d3a.png";